export default "__VITE_ASSET__DZX5qs0c__"